module.exports = __webpack_public_path__ + "static/media/proveoppgave-2.821ad775.mp3";